import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=3509db0f&scoped=true&"
import script from "./selectCustomer.vue?vue&type=script&lang=js&"
export * from "./selectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./selectCustomer.vue?vue&type=style&index=0&id=3509db0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509db0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3509db0f')) {
      api.createRecord('3509db0f', component.options)
    } else {
      api.reload('3509db0f', component.options)
    }
    module.hot.accept("./selectCustomer.vue?vue&type=template&id=3509db0f&scoped=true&", function () {
      api.rerender('3509db0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/list/selectCustomer.vue"
export default component.exports